import { Box, Typography } from '@mui/material';
import React, { ReactElement } from 'react';

export type PeopleSubTabValue = 'attendees' | 'members' | 'leadership';

export const PEOPLE_SUB_TABS: { label: string; value: PeopleSubTabValue }[] = [
  { label: 'Attendees', value: 'attendees' },
  { label: 'Member Roster', value: 'members' },
  { label: 'Leadership', value: 'leadership' },
];

const ACTIVE_COLOR = '#383838';
const INACTIVE_COLOR = '#A7A7A7';
const UNDERLINE_COLOR = '#DEDEDE';

export function PeopleSubTabs ({
  selected,
  onChange,
}: {
  selected: PeopleSubTabValue;
  onChange: (value: PeopleSubTabValue) => void;
}): ReactElement {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        width: '100%',
      }}
    >
      <Box
        display="flex"
        alignItems="flex-start"
        sx={{
          gap: '32px',
          width: '100%',
          overflowX: 'auto',
        }}
      >
        {PEOPLE_SUB_TABS.map(tab => {
          const isSelected = selected === tab.value;
          return (
            <Box
              key={tab.value}
              component="button"
              type="button"
              onClick={() => onChange(tab.value)}
              sx={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                padding: 0,
              }}
            >
              <Typography
                sx={{
                  fontFamily: '\'Poppins\', sans-serif',
                  fontSize: '16px',
                  fontWeight: 500,
                  lineHeight: '24px',
                  color: isSelected ? ACTIVE_COLOR : INACTIVE_COLOR,
                  whiteSpace: 'nowrap',
                }}
              >
                {tab.label}
              </Typography>
            </Box>
          );
        })}
      </Box>
      <Box sx={{ width: '100%', height: '1px', backgroundColor: UNDERLINE_COLOR }} />
    </Box>
  );
}
